module.exports = __webpack_public_path__ + "img/red_error_msg.9f920165.svg";